"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackThirdGenderInCheckout = void 0;
const enums_1 = require("../../enums");
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackThirdGenderInCheckout(label) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: 'SelectGender',
        eventLabel: label,
    });
}
exports.trackThirdGenderInCheckout = trackThirdGenderInCheckout;
//# sourceMappingURL=trackThirdGenderInCheckout.js.map